/** @graphql agg **/
import gql from 'graphql-tag';
import { useCallback } from 'react';
import { useMutationInterop } from '@confluence/apollo-relay-interop';

import type {
	useMarkCommentsAsReadMutation as useMarkCommentsAsReadMutation$data,
	useMarkCommentsAsReadMutationVariables as useMarkCommentsAsReadMutation$variables,
} from './__types__/useMarkCommentsAsReadMutation';

const markCommentsAsReadMutation = gql`
	mutation useMarkCommentsAsReadMutation($commentIds: [ID!]!) {
		markCommentsAsRead(input: { commentIds: $commentIds }) {
			success
			errors
		}
	}
`;

export const useMarkCommentsAsRead = () => {
	const [markCommentsAsRead] = useMutationInterop<
		useMarkCommentsAsReadMutation$data,
		useMarkCommentsAsReadMutation$variables
	>(markCommentsAsReadMutation);

	const markCommentsAsReadFn = useCallback(
		async (commentIds: string[]) => {
			if (commentIds.length === 0) {
				return;
			}

			try {
				await markCommentsAsRead({
					variables: { commentIds },
				});
			} catch (err) {
				// TODO: handle error
				// eslint-disable-next-line no-console
				console.error('Failed to mark comments as read:', err);
			}
		},
		[markCommentsAsRead],
	);

	return markCommentsAsReadFn;
};
